module.exports = __webpack_public_path__ + "static/img/fz_zzb_ys.b86578d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/fz_zzb_ys.png
// module id = z+aa
// module chunks = 0